module.exports = __webpack_public_path__ + "static/img/7.c925db1.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/7.gif
// module id = VJRN
// module chunks = 1